<template>
  <v-container>
    <v-row>
      <v-col v-if="is_authenticated">
          <v-btn type="button" color="primary" @click="redirect('')" class="mr-4">Crear Jugador</v-btn>
        </v-col>
        <v-col v-if="is_authenticated">
          <v-btn type="button" color="primary" @click="downloadFile" class="mr-4">Descargar listado elo</v-btn>
          <p v-if="download">Descargando...</p>
        </v-col>
    </v-row>
    <br>
      <v-row
        no-gutters
      >


        <v-col cols="12" md="3">
          <v-text-field
    label="Buscar Nombre"
    v-model="search_first_name"
    v-debounce:1s="performSearchFirstName"
  >
<template v-slot:prepend-inner>

  <v-icon icon="mdi-magnify" />

</template>
  </v-text-field>
        </v-col>
        <v-col cols="12" md="3" offset-md="1">
          <v-text-field
    label="Buscar Apellido Paterno"
    v-model="search_last_name"
    v-debounce:1s="performSearchLastName"
  >
<template v-slot:prepend-inner>

  <v-icon icon="mdi-magnify" />

</template>
  </v-text-field>
        </v-col>
   <v-col  cols="12" md="3" offset-md="1">
          <v-text-field
    label="Buscar Apellido Materno"
    v-model="search_last_name_second"
    v-debounce:1s="performSearchLastSecondName"
  >
<template v-slot:prepend-inner>

  <v-icon icon="mdi-magnify" />

</template>
  </v-text-field>
        </v-col>
      </v-row>
    </v-container>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">
          Fed. Id
        </th>
        <th class="text-center">
          Fecha Nacimiento
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in players"
        :key="item.id"
      >
        <td class="text-left" style="width: 800px"><a :href="'/player/'+item.id" style="color:blue">{{ item.full_name }}</a></td>
        <td class="text-center">{{ item.federation_id }}</td>
        <td class="text-center">{{ item.birthday_formated }}</td>
      </tr>
    </tbody>
  </v-table>
</template>

<script>
  import gql from "graphql-tag";
  import { vue3Debounce } from 'vue-debounce'
  import {mapState} from "vuex";
  export default {
    directives: {
    debounce: vue3Debounce({ lock: true })
  },
    apollo: {
    players: {query: gql`  query($first_name:String!, $last_name:String!, $last_name_second:String!){
       players(firstName:$first_name, lastName:$last_name, lastNameSecond:$last_name_second){
        id
        full_name:fullName
        birthday_formated:birthdayFormated
        federation_id:federationId
      }
    }`,
      variables() {return {"first_name" :this.first_name_net, "last_name" :this.last_name_net, "last_name_second" :this.last_name_second_net}}

    },
  },
    name:"PlayersChess",
    data () {
      return {
        players:null,
        download:false,
        search_first_name:"",
        search_last_name:"",
        search_last_name_second:"",
        last_name_net:"",
        last_name_second_net:"",
        first_name_net:"",
      }
    },
    computed: {
    ...mapState(['is_authenticated']),
  },
    methods: {
      downloadFile() {
      // Supongamos que la URL del archivo que deseas descargar es esta.
        if(this.download){
          return true
        }
      const fileUrl = '/export_persons_csv';
      this.download = true;
      // Creas un elemento 'a', asignas la URL al atributo 'href' y disparas un click.
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank';
      link.download = 'miarchivo.csv'; // El nombre con el que se guardará el archivo.
      link.click();
    },
    performSearchFirstName(newVal,type ) {
      console.log('debounced', newVal, type)
      this.first_name_net = newVal;
    },
    performSearchLastName(newVal,type ) {
      console.log('debounced', newVal, type)
      this.last_name_net = newVal;
    },
      performSearchLastSecondName(newVal,type ) {
      console.log('debounced', newVal, type)
      this.last_name_second_net = newVal;
    },
      redirect(id){
        if(id){
          window.location.href = '/crear_jugador/' + id
        } else {
          window.location.href = '/crear_jugador'
        }
      },
  },
  }
</script>

